import { gsap } from "gsap"

const GridItem = (props, container) => {
  const PIXI = require('pixi.js')
  const parallax = { offset: Math.floor(Math.random() * Math.floor(800)), ease: Math.random() * (1.5 - 0.5) + 0.5 }
  const pos = { x: 0, y: 0 }
  const size = { width: 0, height: 0 }
  const initial = { x: props.x, y: props.y, width: props.width, height: props.height }
  let wrapper = undefined
  let sprite = undefined
  let mask = undefined
  const parent = {
    parallax,
    loaded: false,
    id: props.id,
    initial,
    pos,
    mq: 0,
    loadImage: (mq) => {
      if (parent.loaded) return
      const mediaquery = mq > 1024 ? 1024 : mq
      const src = `/background/${props.version}/${props.id}/${props.id},w_${mediaquery}.jpg`
      const srcMask = `/background/${props.version}/${props.id}/${props.id},w_${mediaquery}_alpha.jpg`
      const img = new Image()
      img.onload = (e) => {
        const imgElement = e.target
        const imgMask = new Image()
        imgMask.onload = (eMask) => {
          const imgMaskElement = eMask.target
          wrapper = new PIXI.Container()
          wrapper.x = pos.x
          wrapper.y = pos.y
          wrapper.zIndex = props.z
          sprite = PIXI.Sprite.from(imgElement)
          mask = PIXI.Sprite.from(imgMaskElement)
          sprite.width = mask.width = wrapper.width = size.width
          sprite.height = mask.height = wrapper.height = size.height
          parent.mq = mediaquery
          parent.loaded = true
          sprite.mask = mask
          wrapper.addChild(sprite)
          wrapper.addChild(mask)
          container.addChild(wrapper)
          gsap.fromTo(sprite, { alpha: 0, y: 300 }, { duration: 1, alpha: 1, y: 0, ease: `expo.out`, onComplete: () => {
            wrapper.cacheAsBitmap = true
          } } )
        }
        imgMask.src = srcMask
      }
      img.src = src
    },
    activate:() => {
      if (wrapper) wrapper.visible = true
    },
    disactivate:() => {
      if (wrapper) wrapper.visible = false
    },
    remove: () => {
      if (wrapper) {
        wrapper.removeChild(sprite)
        wrapper.removeChild(mask)
        container.removeChild(wrapper)
      }
    },
    setPos: (x, y) => {
      if (x) {
        pos.x = x
        if (wrapper) wrapper.x = pos.x
      }
      if (y) {
        pos.y = y
        if (wrapper) wrapper.y = pos.y
      }
    },
    size: (w, h) => {
      if (w) {
        size.width = w
        if (sprite && mask && wrapper) {
          sprite.width = mask.width = wrapper.width = size.width
        }
      }
      if (h) {
        size.height = h
        if (sprite && mask && wrapper) {
          sprite.height = mask.height = wrapper.height = size.height
        }
      }
    },
  }
  return parent
}

export default GridItem